export default function extractName(categories = []) {
  return categories
    .reduce((subs, cat) => {
      subs.push(cat.name);
      return subs;
    }, [])
    .join(" / ");
}
